import React from 'react';

const Preloader = () => {
  return <div id="preloader"></div>;
};

export default Preloader;
